import React, { useContext } from 'react';
import SearchWindow from '../../../../widgets/searchWindow/SearchWindow';
import { UserProfileContext } from '../../../../common/utils/getContext';
import { transformData } from '../../initData';
import T from '../../../../common/components/T';

const StructureSearchModal = ({ setShowModal, setStructureViewData, afterOpenSwitherClick, setShowReloadBt, setForceOpen }) => {
    const { profileData } = useContext(UserProfileContext) || {};
    return (
        <SearchWindow
            sendData={{
                url: `${profileData.links.descendants}${
                    profileData.links.descendants.indexOf('?') === -1 ? '?' : '&'
                }include=marketingProfile.periods,profile.country,profile.city,sponsor`
            }}
            closeModal={() => setShowModal(false)}
            title={<T textName='search-User' defaultStr='Поиск пользователя' page='/structure' />}
            gridHandlers={{
                tr: {
                    onClick: (rowData) => {
                        setStructureViewData(transformData({ data: [rowData] }));
                        afterOpenSwitherClick(rowData, 'new');
                        setShowModal(false);
                        setShowReloadBt(true);
                        setForceOpen({ data: [rowData] });
                    }
                }
            }}
            customData={{ buttonNotShow: true }}
            fastSearch={true}
        />
    );
};
export default StructureSearchModal;
